import toast from 'react-hot-toast'

let timer: NodeJS.Timeout | null = null

export function showLoadingToast(msg = '加载中') {
	timer = setTimeout(() => {
		toast.loading(msg, {
			id: 'global-loading',
		})
	}, 500)
}

export function hideLoadingToast() {
	if (timer) {
		clearTimeout(timer)
		timer = null
	}
	toast.dismiss('global-loading')
}

export function getParentRadius(innerRadius: number, gap: number) {
	return Math.sqrt(innerRadius ** 2 + gap ** 2)
}
